import Setup from "../../../../../components/categories/superadmin/privilege/setup/Home"

export default function Home() {  
  return (
    <Setup />
  );
}
